import { ColDef } from '@ag-grid-community/core';
import { formatColumnDate, formatMillions, headerInfoTooltipDef } from '../../lib/utils';

export const MA = [
  {
    cellClass: 'ticker-cell',
    field: 'date',
    headerName: 'Announced',
    initialSort: 'desc' as ColDef['initialSort'],
    valueFormatter: ({ data }: any) => formatColumnDate(data.date),
    valueGetter: ({ data }: any) => {
      if (!data.date) return null;
      return data.date;
    },
    width: 120,
    ...headerInfoTooltipDef('Date Potential Deal is announced to the public'),
  },
  {
    cellClass: 'ticker-cell',
    cellRenderer: ({ data }: any) => {
      return (
        <>
          <span>{data.acquirer_name}</span>
          {data.acquirer_ticker && (
            // eslint-disable-next-line react/jsx-no-target-blank
            <a href={`/quote/${data.acquirer_ticker}`} target="_blank">
              ({data.acquirer_ticker})
            </a>
          )}
        </>
      );
    },
    field: 'acquirer_name',
    headerName: 'Acquirer Name',
    width: 160,
    ...headerInfoTooltipDef('Full name and symbol of company doing the acquisition'),
  },
  {
    cellClass: 'ticker-cell',
    cellRenderer: ({ data }: any) => {
      let markup = `<span>${data.target_name}</span>`;
      if (data.target_ticker) {
        markup += ` (<a href="/quote/${data.target_ticker}" target="_blank">${data.target_ticker}</a>)`;
      }
      return markup;
    },
    field: 'target_name',
    headerName: 'Target Name',
    width: 140,
    ...headerInfoTooltipDef('Full name and symbol of the company being acquired'),
  },
  {
    cellClass: 'ticker-cell',
    field: 'deal_type',
    headerName: 'Type',
    width: 120,
    ...headerInfoTooltipDef('Type of deal being proposed for acquisition'),
  },
  {
    field: 'deal_size',
    headerName: 'Size',
    valueFormatter: ({ value }: any) => formatMillions(value, true),
    width: 70,
    ...headerInfoTooltipDef('Monetary value of the acquisition or merger'),
  },
  {
    cellClass: 'ticker-cell',
    field: 'deal_payment_type',
    headerName: 'Payment Type',
    width: 130,
    ...headerInfoTooltipDef('The way the acquiring company plans on paying for the acquisition of the target company'),
  },
  {
    cellClass: 'ticker-cell',
    field: 'deal_status',
    headerName: 'Status',
    width: 120,
    ...headerInfoTooltipDef('Stage in which the deal is currently in'),
  },
];
